import ModalService from './modal-service';

const MODULE_NAME = 'app.common.modal';
const module = angular
    .module(MODULE_NAME, [])
    .service('modalService', ModalService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/common/modal/modal-module.js